import { forwardRef } from "react";

type ChatMessageListProps = {
  children: React.ReactNode;
  dataLoc?: string;
};

export const ChatMessageList = forwardRef<
  HTMLUListElement,
  ChatMessageListProps
>(({ children, dataLoc }, ref) => (
  <ul
    ref={ref}
    className="decideScrollbar flex h-full flex-col gap-y-4 px-2 py-2"
    data-loc={dataLoc}
  >
    {children}
  </ul>
));
